// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Important part */
.modal-dialog {
  overflow-y: initial !important;
}

.modal-body {
  max-height: calc(100vh - 471px);
  overflow-y: auto;
}

.primary {
  margin-left: 5px;
}

.secondary {
  margin-left: 5px;
}

.container {
  display: flex;
  flex-flow: row wrap;
}

h6 {
  text-align: left;
}

.error-small {
  font-size: 12px;
  white-space: pre;
}

.left-padding {
  margin-left: 15px;
  padding-top: 5px;
}

.left-margin {
  margin-left: 23px;
}

.margin-left-postal {
  margin-left: -5px;
}

.z-index {
  z-index: 9000;
}

.check-box-input-margin-left {
  margin-left: 8px;
}

.left-padding-displayGroups {
  padding-left: 40px;
  margin-bottom: 15px;
}

.label-width {
  width: 100px;
}

.left-margin-span {
  margin-left: -5px;
}

.form-control:disabled, .form-control[readonly] {
  background-color: lightgray !important;
  opacity: 1;
}

.grey-out {
  background-color: lightgray !important;
  opacity: 1;
}

/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version. */
.mat-select-disabled, .mat-select-value {
  background-color: lightgray;
}

.mat-mdc-select-panel {
  font-size: 12px;
}

.mat-pseudo-checkbox-checked, .mat-pseudo-checkbox-indeterminate, .mat-accent .mat-pseudo-checkbox-checked, .mat-accent .mat-pseudo-checkbox-indeterminate {
  background: var(--theme-main-background-color, #055C8D);
}

.mat-mdc-select-panel .mat-mdc-optgroup-label, .mat-select-panel .mat-mdc-option {
  font-size: inherit;
  line-height: 1.5;
  height: 2em;
}

.align-select-button {
  margin-top: 25px;
  padding-bottom: 0px;
}

.displayGroupsMargin {
  margin-left: 15px;
}

.check-box-margin {
  margin-left: -6px;
  margin-bottom: 5px;
}

.margins {
  margin-left: -17px;
  margin-right: -14px;
}

.bottom-margin {
  margin-bottom: 0px;
}

.postal-fields-bottom-margin {
  margin-bottom: 0px;
}

.label-margin {
  margin-top: 10px;
}

.error-div {
  height: 30px;
}

body {
  background: #e8cbc0;
  background: linear-gradient(to right, #e8cbc0, #636fa4);
  min-height: 100vh;
}

.bootstrap-select .bs-ok-default::after {
  width: 0.3em;
  height: 0.6em;
  border-width: 0 0.1em 0.1em 0;
  transform: rotate(45deg) translateY(0.5rem);
}

.btn.dropdown-toggle:focus {
  outline: none !important;
}

::ng-deep .cdk-overlay-pane {
  position: absolute;
  pointer-events: auto;
  box-sizing: border-box;
  z-index: 1000;
  display: flex;
  max-width: 100%;
  max-height: 100%;
  background-color: #efedf1;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
